import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { fetchOrderUpdatedHistory } from "../../../api/api";

interface OrderHistory {
  BillNo: string;
  EditedCount: number;
  PartyName: string;
  Date: string;
  user_name: string;
}

const OrderHistoryPage = () => {
  const { t } = useTranslation(); 
  const { billNo } = useParams<{ billNo: string }>();
  const navigate = useNavigate();  
  const [history, setHistory] = useState<OrderHistory[]>([]);

  console.log("URL param billNo:", billNo);
  useEffect(() => {
    const loadHistory = async () => {
      if (!billNo) return;
      const data = await fetchOrderUpdatedHistory(billNo);
      console.log(" Raw API Response:", data);
      if (Array.isArray(data)) {
        const mapped = data.map((row: any) => ({
        BillNo: row.BillNo,
        EditedCount: row.cnt,
        PartyName: row.BillPartyName,
        Date: row.changed_time,
        user_name: row.user_name || row.User || "", 
      }));

        setHistory(mapped);
      }
    };

    loadHistory();
  }, [billNo]);

  // when row clicked
  const handleRowClick = (billNo: string, cnt: number) => {
   navigate(`/order/updated-history-details/${billNo}/${cnt}`);

  };

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0">
            {t("orderHistory")} - {billNo}
          </h4>
        </div>

        <div className="table-responsive">
          <Table bordered hover responsive>
            <thead>
              <tr>
                <th>{t("siNo")}</th>
                <th>{t("billNo")}</th>
                <th>{t("editedCount")}</th>
                <th>{t("partyName")}</th>
                <th>{t("date")}</th>
                <th>{t("user")}</th>
              </tr>
            </thead>
            <tbody>
              {history.length > 0 ? (
                history.map((item, index) => (
                  <tr key={index}
                  style={{ cursor: "pointer" }}
                    onClick={() => handleRowClick(item.BillNo, item.EditedCount)}>
                    <td>{index + 1}</td>
                    <td>{item.BillNo}</td>
                    <td>{item.EditedCount}</td>
                    <td>{item.PartyName}</td>
                    <td>{item.Date}</td>
                    <td>{item.user_name}</td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="text-center">
                    {t("noHistoryFound")}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default OrderHistoryPage;
